import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import TopBar from './TopBar';
interface LayoutProps {
  children: React.ReactNode;
}
const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-172">
      <TopBar data-id="element-173" />
      <Navbar data-id="element-174" />
      <main className="flex-grow" data-id="element-175">{children}</main>
      <Footer data-id="element-176" />
    </div>;
};
export default Layout;